/* One Shopify quantity is one serum bottle. Shopify enforces the automatic BOGO price. */
(() => {
  'use strict';
  const node = document.getElementById('co-bogo-units-config');
  if (!node || window.coBogoUnits) return;
  const config = JSON.parse(node.textContent), variant = String(config.variant);
  const unitMarker = '_co_bogo_units', nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let cart = config.cart, serial = Promise.resolve(), pending = 0, checkoutPass = false;
  const isBogo = item => String(item.variant_id || item.id) === variant;
  const isUnits = item => item.properties?.[unitMarker] === '1';
  const relevant = () => cart?.items?.some(isBogo) || pending;
  const state = c => JSON.stringify(c.items.map(i => [i.key, i.quantity, i.final_line_price]));
  const enqueue = task => {const result=serial.then(task);serial=result.catch(()=>{});return result;};
  function remember(c) {cart=c;document.documentElement.toggleAttribute('data-co-bogo-units',c.items.some(isBogo));return c;}
  async function api(path, payload) {
    const response = await nativeFetch(root+path, payload === undefined ? {} : {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
    if (!response.ok) throw new Error('Your cart could not be updated. Please reload and try again.');
    return response.json();
  }
  async function normalize(c) {
    const legacy=c.items.filter(i=>isBogo(i)&&!isUnits(i));
    if (legacy.length) {
      await api('cart/update.js',{updates:Object.fromEntries(legacy.map(i=>[i.key,0]))});
      await api('cart/add.js',{items:legacy.map(i=>({id:Number(variant),quantity:i.quantity*2,properties:{...i.properties,[unitMarker]:'1'}}))});
      c=await api('cart.js');
    }
    // Shopify may split paid/free quantities. Parity belongs to the complete offer,
    // never to individual discounted rows (rounding each row would double it).
    const quantity=c.items.filter(isBogo).reduce((n,i)=>n+i.quantity,0);
    if (quantity%2) {await api('cart/add.js',{items:[{id:Number(variant),quantity:1,properties:{[unitMarker]:'1'}}]});c=await api('cart.js');}
    return remember(c);
  }
  function assertPrice(c) {
    const lines=c.items.filter(isBogo);
    const due=lines.reduce((n,i)=>n+i.final_line_price,0);
    const ceiling=lines.reduce((n,i)=>n+i.original_price*i.quantity/2,0);
    if (lines.some(i=>!isUnits(i)) || lines.reduce((n,i)=>n+i.quantity,0)%2 || due>Math.ceil(ceiling)) throw new Error('Your Buy 1 Get 1 Free offer could not be confirmed. Please refresh your cart before checking out.');
  }
  function message(error) {
    let el=document.getElementById('co-bogo-units-error');
    if (!el) {el=document.createElement('div');el.id='co-bogo-units-error';el.setAttribute('role','alert');el.style.cssText='position:fixed;bottom:20px;left:5%;right:5%;padding:14px;background:#fff1f3;color:#8d1233;border:1px solid #d10052;z-index:999999;border-radius:8px;font:14px/1.4 sans-serif';document.body.append(el);}
    el.textContent=error.message;
  }
  function parse(body) {
    if (typeof body==='string') {try{return JSON.parse(body);}catch(_){body=new URLSearchParams(body);}}
    if (!(body instanceof FormData)&&!(body instanceof URLSearchParams)) return null;
    const result={},items=[];
    for (const [key,value] of body.entries()) {
      let m=key.match(/^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?$/);
      if (m) {const row=items[Number(m[1])]||={};if(m[3])(row[m[2]]||={})[m[3]]=value;else row[m[2]]=value;}
      else if ((m=key.match(/^properties\[([^\]]+)\]$/))) (result.properties||={})[m[1]]=value;
      else if ((m=key.match(/^updates\[([^\]]+)\]$/))) (result.updates||={})[m[1]]=value;
      else result[key]=value;
    }
    if(items.length)result.items=items.filter(Boolean);
    return result;
  }
  async function sections(data) {
    if(!data.sections)return null;
    const url=new URL(data.sections_url||location.pathname,location.origin);
    url.searchParams.set('sections',Array.isArray(data.sections)?data.sections.join(','):data.sections);
    const r=await nativeFetch(url);if(!r.ok)throw new Error('Please reload your cart.');return r.json();
  }
  window.fetch=function(input,init) {
    const url=new URL(typeof input==='string'||input instanceof URL?input:input.url,location.origin);
    const endpoint=url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/)?.[1];
    if(url.origin!==location.origin || (init?.method||input?.method||'GET').toUpperCase()!=='POST'||!endpoint||!init?.body)return nativeFetch(input,init);
    const data=parse(init.body);if(!data)return nativeFetch(input,init);
    const requested=data.items||(data.id?[{id:data.id,quantity:data.quantity||1,properties:data.properties,selling_plan:data.selling_plan}]:[]);
    const adding=endpoint==='add'&&requested.some(isBogo);
    if(!adding&&!relevant())return nativeFetch(input,init);
    return enqueue(async()=>{
      pending++;
      try {
        // Old carts are migrated before an add so legacy pack lines never merge into bottle lines.
        if(cart?.items?.some(i=>isBogo(i)&&!isUnits(i))) await normalize(await api('cart.js'));
        if(endpoint==='change'){
          const target=data.line?cart.items[Number(data.line)-1]:cart.items.find(i=>i.key===String(data.id)||String(i.variant_id)===String(data.id));
          if(target&&isBogo(target)){
            const quantity=Math.max(0,Math.ceil(Number(data.quantity||0)/2)*2);
            const updates=Object.fromEntries(cart.items.filter(isBogo).map(i=>[i.key,0]));
            await api('cart/update.js',{updates});
            if(quantity)await api('cart/add.js',{items:[{id:Number(variant),quantity,properties:{...target.properties,[unitMarker]:'1'}}]});
            const current=await normalize(await api('cart.js'));assertPrice(current);
            return new Response(JSON.stringify({...current,sections:await sections(data)}),{status:200,headers:{'Content-Type':'application/json'}});
          }
        }
        let outgoing=data;
        if(adding){outgoing={...data,items:requested.map(i=>isBogo(i)?{...i,quantity:Number(i.quantity||1)*(isUnits(i)?1:2),properties:{...i.properties,[unitMarker]:'1'}}:i)};delete outgoing.id;delete outgoing.quantity;delete outgoing.properties;delete outgoing.selling_plan;}
        const headers=new Headers(init.headers||{});headers.set('Content-Type','application/json');headers.set('Accept','application/json');
        const response=await nativeFetch(input,{...init,headers,body:JSON.stringify(outgoing)});if(!response.ok)return response;
        const result=await response.clone().json();let current=endpoint==='add'?await api('cart.js'):result;
        const before=state(current);current=await normalize(current);
        let output=endpoint==='add'?result:{...current,sections:result.sections};
        if(before!==state(current))output.sections=await sections(data)||output.sections;
        if(endpoint==='add'&&!data.items&&result.items)output={...result.items.find(isBogo),...output};
        try{assertPrice(current);}catch(error){message(error);}
        return new Response(JSON.stringify(output),{status:response.status,statusText:response.statusText,headers:response.headers});
      }catch(error){message(error);throw error;}finally{pending--;}
    });
  };
  async function checkout(callback){try{await enqueue(async()=>assertPrice(await normalize(await api('cart.js'))));checkoutPass=true;try{callback();}finally{checkoutPass=false;}}catch(error){message(error);}}
  document.addEventListener('click',event=>{const control=event.target.closest('button[name="checkout"],input[name="checkout"],a[href^="/checkout"],button[onclick*="checkoutLoad"]');if(!control||checkoutPass||!relevant())return;event.preventDefault();event.stopImmediatePropagation();checkout(()=>control.click());},true);
  document.addEventListener('submit',event=>{if(checkoutPass||event.submitter?.name!=='checkout'||!relevant())return;event.preventDefault();event.stopImmediatePropagation();checkout(()=>event.target.requestSubmit(event.submitter));},true);
  window.coBogoUnits={normalize,parse,assertPrice,getCart:()=>cart};
  remember(cart);
  if(relevant())enqueue(async()=>{const before=state(cart);const next=await normalize(await api('cart.js'));if(before!==state(next))location.reload();}).catch(message);
})();
